import Button from "components/UI/Button/Button";
import styles from "./NavigationButtons.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useContext, useEffect, useState } from "react";
import { QuizContext } from "context/QuizContext";

type NavigationButtonsProps = {
  backSelected?: boolean;
  endQuizSelected: boolean;
  questionIndex?: number;
};

export default function NavigationButtons({
  backSelected,
  endQuizSelected,
  questionIndex,
}: NavigationButtonsProps) {
  const { categoryIndex, currentCategory } = useContext(QuizContext);
  const [color, setColor] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (currentCategory) {
      switch (currentCategory.color) {
        case "#1271b4":
          setColor("blue");
          break;
        case "#ed6057":
          setColor("red");
          break;
        case "#a1e3d2":
          setColor("green");
          break;
        case "#ffce0e":
          setColor("yellow");
          break;
        case "#b84f9a":
          setColor("purple");
          break;
      }
    }
  }, [currentCategory]);

  return (
    <>
      <div className={styles.navigationButtons}>
        <Button
          inactive={
            categoryIndex
              ? questionIndex === 0 && categoryIndex === 0
              : questionIndex === 0
          }
          color={color}
          variant={backSelected ? "secondary" : "primary"}
        >
          <FontAwesomeIcon icon={faChevronLeft} /> Vorige vraag
        </Button>
        <Button
          color={color}
          variant={endQuizSelected ? "secondary" : "primary"}
        >
          <FontAwesomeIcon icon={faTimes} /> Stoppen
        </Button>
      </div>
    </>
  );
}
